import { CatTableBody } from '@blocks-react/components/TableBody';

import { ChildProps } from '../../types';

export const CVATableBody = ({ children }: Readonly<ChildProps>) => {
  return <CatTableBody>{children}</CatTableBody>;
};
